export default {
  title: 'Potwierdzenie hasła',
  type: 'object',
  properties: {
    password: {
      type: 'string',
      title: 'Hasło',
      fieldRequired: true,
      minLength: 14,
      validFunc: 'return new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{14,}$").test($value)',
      validationMessages: {
        required: 'Hasło jest wymagane',
        minLength: 'Minimalna długość hasła wynosi 14',
        validFunc: 'Hasło powinno zawierać co najmniej jedną dużą literę, jedną małą literę, cyfrę oraz znak specjalny'
      }
    },
    repeat: {
      type: 'string',
      title: 'Powtórz hasło',
      fieldRequired: true,
      validFunc: '$value && this.password ? $value === this.password : true',
      validationMessages: {
        required: 'Powtórzenie hasła jest wymagane',
        validFunc: 'Oba hasła muszą być takie same'
      }
    }
  }
};
